import type { Component } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import { toCompVariants } from '../../utils/toCompVariants'
import type { FeatureRefs } from '../cssFeatures.types'
import { isRefArray } from '../../utils/variantsUtils'

export const designVariants = createCssCompNode('compCssMappers', 'designVariants', {
	getDependencies: (component: Component, refs: FeatureRefs<'compCssMappers'>) =>
		component.designQuery ? refs.designQuery(component.designQuery) : undefined,
	toViewItem: (__, refArray) => (isRefArray(refArray) ? toCompVariants(refArray.values) : null),
})
